<div [ngClass]="type">
  @switch (type) {
    @case ('error') {
      <mat-icon>error</mat-icon>
    }
    @case ('warning') {
      <mat-icon>warning</mat-icon>
    }
    @case ('info') {
      <mat-icon>info</mat-icon>
    }
    @default {
      <mat-icon>done</mat-icon>
    }
  }
  <ng-content></ng-content>
</div>
